export const platformTypes = {
  FETCH_PLATFORM_DATA: 'platform/GETTING_DATA',
};

export const setPlatform = (data) => ({
  type: platformTypes.FETCH_PLATFORM_DATA,
  data,
});
